// @flow

import React from 'react';
import styled from 'styled-components';

import Header from '../Header';
import Footer from '../Footer';
import Metrika from '../Metrika';

type Props = {
  children?: any,
};

const Wrapper = styled.section`
  display: flex;
  flex-flow: column;
  align-items: center;
  min-height: calc(100vh - 36px);
`;

const Body = styled.main`
  position: relative;
  display: flex;
  flex-flow: column;
  flex: 1;
  align-items: center;
  width: 100%;
`;

const Page = (props: Props) => (
  <Wrapper>
    <Header />
    <Body>{props.children}</Body>
    <Footer />

    {process.env.NODE_ENV === 'production' && <Metrika />}
  </Wrapper>
);

export default Page;



// WEBPACK FOOTER //
// ./src/components/Page/index.js